import 'react-datepicker/dist/react-datepicker.css'
import { FullCalendarRangePicker } from '@/common/datepicker/FullCalendarRangePicker.jsx'
import { FullCalendarToolbar } from '@/common/fullcalendar/fullcalendartoolbar.jsx'

export function CalendarToolbar({ calendarRef, appliedRange, viewRange, onApply, onReset, dateRange = false }) {
	return dateRange ? (
		<FullCalendarToolbar
			calendarRef={calendarRef}
			onTodayClick={onReset}
			calendarController={
				<FullCalendarRangePicker appliedRange={appliedRange} viewRange={viewRange} onApply={onApply} />
			}
		/>
	) : (
		<FullCalendarToolbar calendarRef={calendarRef} />
	)
}
